module.exports = __webpack_public_path__ + "static/media/usedsoloshow2.58cdae23.JPG";